import './ScrollButton.scss';
import { ENTER_KEY_CODE } from '../../utils/constants';
import arrowToTop from '../../assets/images/ubisoft-playtest-icon-top.webp';
import { scrollToTop } from '../../utils/generic';
import { useState } from 'react';

const MIN_HEIGHT_BEFORE_BUTTON_DISPLAY = 300;

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    scrolled > MIN_HEIGHT_BEFORE_BUTTON_DISPLAY
      ? setVisible(true)
      : setVisible(false);
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <>
      {visible && (
        <div
          className="scroll-button"
          onClick={scrollToTop}
          tabIndex={0}
          onKeyDown={(e: any) => {
            if (e.keyCode == ENTER_KEY_CODE) e.target.click();
          }}
        >
          <img src={arrowToTop} alt="" />
        </div>
      )}
    </>
  );
};

export default ScrollButton;
